import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { Fuel } from "lucide-react";

import { useTranslation } from "react-i18next";
export default function ResetPassword() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error(t("auth.resetpassword.passwords_do_not_match"));
    if (pw.length < 6) return toast.error(t("auth.resetpassword.password_must_be_at_least_6_characters"));
    if (!token) return toast.error(t("auth.resetpassword.missing_reset_token_request_a_new_link"));
    setSubmitting(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: pw });
      toast.success(t("auth.resetpassword.password_updated_please_log_in"));
      nav("/login", { replace: true });
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-lg bg-amber-500 text-2xl font-black text-white">
            <Fuel className="h-7 w-7" />
          </div>
          <div className="text-2xl font-bold text-foreground">{t("auth.resetpassword.set_a_new_password")}</div>
        </div>
        <Card className="border-border">
          <CardHeader>
            <CardTitle className="text-lg">{t("auth.resetpassword.enter_new_password")}</CardTitle>
            <p className="text-xs text-muted-foreground">{t("auth.resetpassword.choose_at_least_6_characters_once_you_sa")}</p>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="pw">{t("auth.resetpassword.new_password")}</Label>
                <Input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)}
                       data-testid="reset-new-password"
                       className="h-11 text-base md:h-9 md:text-sm" required />
              </div>
              <div>
                <Label htmlFor="pw2">{t("auth.resetpassword.confirm_new_password")}</Label>
                <Input id="pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)}
                       data-testid="reset-confirm-password"
                       className="h-11 text-base md:h-9 md:text-sm" required />
              </div>
              <Button type="submit" className="h-11 w-full md:h-10" disabled={submitting} data-testid="reset-submit">
                {submitting ? "Updating…" : "Update password"}
              </Button>
            </form>
            <div className="mt-4 text-center text-xs text-muted-foreground">
              <Link to="/login" className="font-semibold text-amber-600 hover:underline">{t("auth.resetpassword.back_to_sign_in")}</Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
